import React, {ReactNode, ReactChildren, ReactChild, useCallback} from 'react';
import {asyncChannelClickTracker} from '../utils/traker';
import {useGlobalState} from "../contexts/GlobalState";

interface IProps {
  children: ReactNode|ReactChildren|ReactChild,
  channelId: number;
  outLink?: string|undefined;
  widgetId?: number;
  target?: string;
  rel?: string;
  className?: string;
  competitionId?: number;
  title?: string;
}

const ChannelTrackingLink: React.FC<IProps> = ({
  children,
  channelId,
  outLink = undefined,
  widgetId = undefined,
  target = undefined,
  rel = undefined,
  className = undefined,
  competitionId = undefined,
  title = undefined,
}) => {
  const {globalState} = useGlobalState()

  const getWidgetId = useCallback((): number => {
    if (widgetId) {
      return widgetId
    }
    
    if (globalState.widget) {
      return globalState.widget.id
    }

    throw new Error('Widget error: Unknown widgetId')
  }, [widgetId, globalState.widget])

  const onClick = useCallback(() => {
    if (outLink) {
      asyncChannelClickTracker(
        getWidgetId(),
        channelId,
        outLink,
        competitionId,
      )
    }
  }, [competitionId, getWidgetId, outLink, channelId])

  return (
    <a href={outLink} target={target} rel={rel} className={className} onClick={onClick} title={title}>
      {children}
    </a>
  )
};

export default ChannelTrackingLink;
